import CryptoJS from 'crypto-js'

export function generateHmacHeaders({
  method,
  url,
  data,
  secret,
}: {
  method: string
  url: string
  data: any
  secret: string
}) {
  const jsonData = data ? JSON.stringify(data) : '{}'
  const timestamp = Date.now().toString()
  const message = `${method.toUpperCase()}:${url}:${jsonData}:${timestamp}`

  const signature = CryptoJS.HmacSHA256(message, secret).toString()
  return {
    'X-Timestamp': timestamp,
    'X-Signature': signature,
  }
}
